var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrunei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 39.9972C31.0443 39.9972 39.9973 31.0442 39.9973 20.0001C39.9973 8.95605 31.0443 0.00305176 20.0002 0.00305176C8.95617 0.00305176 0.00317383 8.95605 0.00317383 20.0001C0.00317383 31.0442 8.95617 39.9972 20.0002 39.9972Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68217 10.0015C1.77957 11.5646 1.11378 13.1989 0.67041 14.8635L34.1132 34.1718C35.3331 32.9555 36.4156 31.5616 37.318 29.9985L2.68217 10.0015Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9988 2.68201C21.9974 -1.93755 12.1315 -0.397903 5.88708 5.82817L39.3298 25.1363C41.5997 16.6157 38 7.30164 29.9988 2.68201V2.68201Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0016 37.318C18.0029 41.9375 27.869 40.3979 34.1132 34.1719L0.670388 14.8635C-1.59927 23.3844 2.00018 32.6984 10.0016 37.318Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6515 17.8263C25.6515 20.9474 23.1213 23.4777 20.0001 23.4777C16.8789 23.4777 14.3487 20.9475 14.3487 17.8263C14.3487 16.8532 14.5947 15.9375 15.028 15.138C13.8017 16.3922 13.0446 18.1072 13.0446 19.9999C13.0446 23.8413 16.1586 26.9554 20.0001 26.9554C23.8416 26.9554 26.9556 23.8414 26.9556 19.9999C26.9556 18.1072 26.1986 16.3922 24.9722 15.138C25.4054 15.9376 25.6515 16.8532 25.6515 17.8263V17.8263Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.696 11.3057H21.3044V24.3473H18.696V11.3057Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3473 13.9139H15.653C15.653 14.5142 16.1759 15.0008 16.776 15.0008H16.7398C16.7398 15.601 17.2264 16.0876 17.8266 16.0876C17.8266 16.6878 18.3132 17.1744 18.9134 17.1744H21.087C21.6872 17.1744 22.1738 16.6878 22.1738 16.0876C22.774 16.0876 23.2606 15.601 23.2606 15.0008H23.2244C23.8245 15.0007 24.3473 14.5143 24.3473 13.9139Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9142 25.2167H26.0863V27.825H13.9142V25.2167Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6084 26.0862H27.825V28.6945H22.6084V26.0862Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1753 26.0862H17.3919V28.6945H12.1753V26.0862Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrunei);
export default __webpack_public_path__ + "static/media/brunei.ccc419d9419471b18d84ff03e4e0072a.svg";
export { ForwardRef as ReactComponent };